import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TourAttentionDto } from '@/features/dashboard/tours/types/attention/TourAttentionDto.ts';

/**
 * Panele „Wymaga uwagi” Podsumowania i Opcji. Osobny moduł backendu, nie
 * statystyki: sprawy są materializowane i mają własny czas przeliczenia.
 */
const tourAttentionApi = {
  getForTour: async (tourId: string): Promise<TourAttentionDto> => {
    return await fetchPrivateApi<TourAttentionDto>(
      'GET',
      `attention/tours/${tourId}`,
    );
  },
};

export default tourAttentionApi;
